<template>
  <div
    class="newsletter">
    <p v-html="note"></p>
    <form
      v-if="!formSubmitted"
      @submit.prevent="signup"
      class="newsletter__form">
      <div class="newsletter__form-row">
        <input
          type="text"
          name="name"
          v-model="name"
          placeholder="Name"
          autocomplete="off"
          required />
        <input
          type="email"
          name="email"
          v-model="email"
          placeholder="Email Address"
          autocomplete="off"
          required />
      </div>
      <div class="newsletter__form-row">
        <button
          :disabled="typeof email === typeof null || email === '' || email.length < 5"
          class="newsletter__form-btn">
          Submit
        </button>
      </div>

    </form>

    <div
      v-if="success"
      class="newsletter__success">
      <p v-html="success"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Newsletter',
  props: {
    note: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      name: null,
      email: null,
      submitting: false,
      formSubmitted: false,
      success: false,
      mailchimp: {
        uid: 'eb6d01cee3acfd94ac15c408b',
        formId: '72bc3542bf',
        url: `https://molonglogroup.us17.list-manage.com/subscribe/post-json`
      }
    }
  },
  methods: {
    // Submit newsletter to Mailchimp and handle repsonse
    async signup() {
      // validate form
      if (this.validateForm()) {
        this.submitting = true

        const success = await this.submitToMailChimp()

        if (success) {
          this.formSubmitted = true
          this.success = success
          setTimeout(() => {
            this.submitting = false
            this.isSubmitted = true
          }, 500)
        }
      }
    },
    validateForm() {
      // form passed validation
      return true
    },
    submitToMailChimp(form) {
      const url = `${this.mailchimp.url}?u=${this.mailchimp.uid}&id=${this.mailchimp.formId}&EMAIL=${this.email}&NAME=${this.name}`

      return new Promise(resolve => {
        this.$http.jsonp(url, {
          jsonp: 'c',
          'EMAIL': this.email,
          'NAME': this.name
        })
          .then(result => {
            console.log(result)
            // success
            if (result.body.result === 'success') {
              if (result.body.msg) {
                resolve(`Thank you, please check your email to confirm your sign up.`)
              }
            }

            // error
            if (result.body.result === 'error') {
              // error => user is already signed up
              if (result.body.msg.includes(this.email)) {
                resolve(`You are already subscribed. Thanks again ${this.name}.`)
              }

              // error generally error
              resolve('We are currently having difficulty processing your sign up, please try again later.')
            }
          })
      })
    },
    handleJSONCallback(response) {
      console.log(response)
    }
  }
}
</script>

<style lang="scss" scoped>
.newsletter {
  width: 100%;
  margin: $padding 0 $page-padding 0;
  max-width: calc(66.6% - #{$padding});

  &__form {
    margin: $padding 0 0 0;

    &-row {
      display: flex;
    }

    input {
      display: block;
      width: 100%;
      border: 3px solid #000;
      color: #000;
      border-radius: 0px;
      padding: 6px 10px;
      font-size: $body;
      margin: 0 #{$padding / 2}  0 0;

      &::placeholder {
        color:#000;
      }
    }

    button {
      appearance: none;
      font-family: $suisse;
      // line-height: 0.75;
      vertical-align: middle;
      border: 3px solid #000;
      padding: 6px 10px;
      background: transparent;
      font-size: $body;
      margin: #{$padding / 2} 0 0 0;

      &[disabled="disabled"] {
        border-color: rgba(0, 0, 0, 0.65);
      }

      &:hover {
        cursor:pointer;
      }
    }
  }

  &__success {
    // margin: 5px 0;
    margin: #{$padding * 6}  0 #{$padding * 4} 0;
  }

  @media screen and (max-width: 768px) {
    max-width: unset;
    margin: 0px;
    &__form {
      margin: #{$padding * 1}  0 #{$padding * 1} 0;

      &-row {
        flex-wrap: wrap;
      }

      input, button {
        font-size: calc(#{$body--m} + 1px);
        margin: 0 0 #{$padding / 2} 0;
        border: 2px solid;
        padding: 4px 8px;
      }

      input {
        width: 100%;
      }
    }

    &__success {
      margin: #{$padding * 3}  0 #{$padding * 1.5} 0;
    }
  }
}
</style>
